import { WidgetType } from 'domain/entity/widget';
import WidgetData, { Color, WidgetDataAvailability, WidgetDescription } from 'domain/entity/widgetData';
import { ChartAxisType, Resolution } from 'domain/entity/widgets/ChartData';

export type HeatmapValue = { x: Date | string; y: string; v: number };

export type DatetimeMeta = {
    timezone: string;
    resolution: Resolution;
    from: Date;
    to: Date;
};

export type CategorizedMeta = {
    categories: string[];
};

export type DayHourMeta = any;

export type HeatmapAxis = {
    type: ChartAxisType;
    title: string;
    units: string;
    meta: DatetimeMeta | CategorizedMeta | DayHourMeta;
};

export type HeatmapPalette = {
    colors: Color[];
    positions: number[];
};

export type HeatmapWidgetData = WidgetData & {
    series: HeatmapSeries;
    axisX: HeatmapAxis;
    axisY: HeatmapAxis;
};

export type HeatmapSeries = {
    values: HeatmapValue[];
    palette: HeatmapPalette;
    title: string;
    units: string;
};

class HeatmapData implements HeatmapWidgetData {
    readonly type = WidgetType.HEATMAP;

    constructor(
        readonly description: WidgetDescription,
        readonly series: HeatmapSeries,
        readonly axisX: HeatmapAxis,
        readonly axisY: HeatmapAxis,
        readonly dataAvailability: WidgetDataAvailability
    ) {}
}

export default HeatmapData;
